import { render, staticRenderFns } from "./ViewFilesGrid.vue?vue&type=template&id=37ae6e1f&scoped=true&"
import script from "./ViewFilesGrid.vue?vue&type=script&lang=js&"
export * from "./ViewFilesGrid.vue?vue&type=script&lang=js&"
import style0 from "./ViewFilesGrid.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ViewFilesGrid.vue?vue&type=style&index=1&id=37ae6e1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ae6e1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ae6e1f')) {
      api.createRecord('37ae6e1f', component.options)
    } else {
      api.reload('37ae6e1f', component.options)
    }
    module.hot.accept("./ViewFilesGrid.vue?vue&type=template&id=37ae6e1f&scoped=true&", function () {
      api.rerender('37ae6e1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EHR/HistoryAndReports/Uploadhistory/ViewFilesGrid.vue"
export default component.exports